import { render, staticRenderFns } from "./ConfirmEncerramentoContrato.vue?vue&type=template&id=54d2bc27&lang=html"
import script from "./ConfirmEncerramentoContrato.vue?vue&type=script&lang=js"
export * from "./ConfirmEncerramentoContrato.vue?vue&type=script&lang=js"
import style0 from "./ConfirmEncerramentoContrato.vue?vue&type=style&index=0&id=54d2bc27&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports